import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { DOWNLOAD_QUERY_ASYNC } from './useSqlhooks';

export const useAsyncDownload = () => {
  // Mutation for async download
  const [downloadQueryAsync] = useMutation(DOWNLOAD_QUERY_ASYNC);

  // Start async download
  const startAsyncDownload = useCallback(async (sqlQuery, userId, userDbId, columns, rows, data, dbType, format = 'csv', downloadType = 'plain', tabName) => {
    try {
      const result = await downloadQueryAsync({
        variables: {
          sqlQuery,
          userId,
          userDbId,
          columns,
          rows,
          data,
          db_type: dbType,
          format,
          downloadType,
          tabName
        }
      });

      if (result.data?.downloadQueryAsync?.success) {
        return {
          success: true,
          jobId: result.data.downloadQueryAsync.data.jobId,
          message: result.data.downloadQueryAsync.message
        };
      } else {
        return {
          success: false,
          error: result.data?.downloadQueryAsync?.message || 'Download failed'
        };
      }
    } catch (error) {
      console.error('Async download error:', error);
      return {
        success: false,
        error: error.message || 'Download failed'
      };
    }
  }, [downloadQueryAsync]);

  return {
    startAsyncDownload
  };
};